import React from 'react';
import { motion, HTMLMotionProps } from 'framer-motion';
import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';
function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
interface ButtonProps extends HTMLMotionProps<'button'> {
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'sm' | 'md' | 'lg' | 'xl';
  glow?: boolean;
}
export function Button({
  className,
  variant = 'primary',
  size = 'md',
  glow = false,
  children,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center rounded-full font-bold transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:pointer-events-none';
  const variants = {
    primary: 'bg-[#22C55E] text-black hover:bg-[#16a34a] focus:ring-[#22C55E]',
    secondary: 'bg-[#F59E0B] text-black hover:bg-[#d97706] focus:ring-[#F59E0B]',
    outline: 'border-2 border-[#22C55E] text-[#22C55E] hover:bg-[#22C55E]/10'
  };
  const sizes = {
    sm: 'h-9 px-4 text-sm',
    md: 'h-11 px-6 text-base',
    lg: 'h-14 px-8 text-lg',
    xl: 'h-16 px-10 text-xl'
  };
  const glowStyles = glow ? 'shadow-[0_0_20px_rgba(34,197,94,0.5)] animate-pulse' : '';
  return <motion.button whileHover={{
    scale: 1.05
  }} whileTap={{
    scale: 0.95
  }} className={cn(baseStyles, variants[variant], sizes[size], glowStyles, className)} {...props} data-id="element-150">
      {children}
    </motion.button>;
}